module.exports = __webpack_public_path__ + "img/dollar-coin.cc08c865.svg";